import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import useAuthService from "../../session/useAuthService";
import { getDoctorsList, getDoctorSpecialities } from "../../api/Doctor";
import { Empty, Pagination } from "antd";
import moment from "moment-timezone";
import { getResourceThumbnail } from "../../customJS/custom";
import { userBlockOrUnblock } from "../../api/User";
import Loader from "../../customJS/Loader";
import { Icon } from "@iconify/react/dist/iconify.js";

export const BlockedDoctors = () => {
  const [loader, setLoader] = useState(false);
  const [doctorsList, setDoctorsList] = useState([]);
  const [paginationCount, setPaginationCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    getDoctorsLists();
  }, [currentPage]);

  const getDoctorsLists = () => {
    let obj = {
      hospitalId:
        useAuthService.getUserType() === "1"
          ? 0
          : useAuthService.getHospitalId(),
      pageNo: currentPage,
      flag: "D",
      userType: useAuthService.getUserType(),
    };
    getDoctorsList(obj)
      .then((response) => {
        if (response.data.status === 1) {
          console.log(response.data.data);
          setDoctorsList(response.data.data.doctorsLists);
          console.log(
            "response.data.data.doctorsLists:::",
            response.data.data.doctorsLists
          );
          setPaginationCount(response.data.data.totalCount);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const blockUser = (userId) => {
    let obj = { userId: userId, flag: "A" };
    setLoader(true);
    userBlockOrUnblock(obj)
      .then((response) => {
        if (response.data.status === 1) {
          console.log("Success:", response.data);
          getDoctorsLists();
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const onPageChange = (newCurrent) => {
    setCurrentPage(newCurrent - 1);
  };

  return (
    <Row className="m-0">
      {loader && <Loader />}
      <Col xs="12">
        <div className="d-flex  m-4">
          <h2 className="uniteColor font-weight700">Blocked Providers</h2>
        </div>
      </Col>
      <Col xs="12" className="table-width table-responsive mb-3">
        {doctorsList.length === 0 ? (
          <Empty />
        ) : (
          <Table className="unitedTable m-0" hover>
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Speciality</th>
                {useAuthService.getUserType() === "1" && <th>Provider</th>}
                <th>Email</th>
                <th>Phone</th>
                <th>Blocked date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {doctorsList?.map((doctor) => (
                <tr key={doctor.doctorId}>
                  <td align="center">
                  {doctor.image ? (
                      getResourceThumbnail(doctor.image)
                    ) : (
                      <Icon
                        icon={
                          doctor.gender === "FEMALE"
                            ? "et:profile-female"
                            : "et:profile-male"
                        }
                        width="30"
                        height="30"
                        style={{ color: "#0D224E" }}
                      />
                    )}
                    </td>
                  <td>{doctor.displayName}</td>
                  <td>{doctor.specialityName}</td>
                  {useAuthService.getUserType() === "1" && (
                    <td>{doctor.hospitalName}</td>
                  )}
                  {/* <td>{doctor.hospitalName}</td> */}
                  <td>{doctor.mailId}</td>
                  <td>{doctor.phoneNo}</td>
                  <td>
                    {moment(doctor.blockedDate, "YYYY-MM-DD HH:mm").format(
                      "DD/MM/YYYY"
                    )}
                  </td>
                  <td>
                    <Button
                      className="uniteButton-outline"
                      onClick={() => blockUser(doctor.userId)}
                    >
                      Un Block
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Col>
      {paginationCount > 12 && (
        <Col>
          <Pagination
            current={currentPage + 1}
            defaultCurrent={1}
            total={paginationCount}
            defaultPageSize={12}
            onChange={onPageChange}
            showSizeChanger={false}
          />
        </Col>
      )}
    </Row>
  );
};
